// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { MutationCreateContractPartnerArgs, MutationDeleteContractPartnerArgs } from '../../../mdqx-graphql-types';
import { ContractPartnerEntity } from '../../../entities/mdqx/contract-partner.entity';

export enum ContractPartnerActionTypes {
    GetRequest = '[ContractPartners] Get Request',
    GetResponse = '[ContractPartners] Get Response',
    PostRequest = '[ContractPartner] Post Request',
    PostResponse = '[ContractPartner] Post Response',
    DeleteRequest = '[ContractPartner] Delete Request',
    DeleteResponse = '[ContractPartner] Delete Response',
}

export class GetContractPartnersRequest implements Action {
    readonly type = ContractPartnerActionTypes.GetRequest;
}

export class GetContractPartnersResponse implements Action {
    readonly type = ContractPartnerActionTypes.GetResponse;
    constructor(public Payload: ContractPartnerEntity[]) {}
}

export class PostContractPartnerRequest implements Action {
    readonly type = ContractPartnerActionTypes.PostRequest;
    constructor(public Payload: MutationCreateContractPartnerArgs) {}
}

export class PostContractPartnerResponse implements Action {
    readonly type = ContractPartnerActionTypes.PostResponse;
    constructor(public Payload: ContractPartnerEntity) {}
}

export class DeleteContractPartnerRequest implements Action {
    readonly type = ContractPartnerActionTypes.DeleteRequest;
    constructor(public Payload: MutationDeleteContractPartnerArgs) {}
}

export class DeleteContractPartnerResponse implements Action {
    readonly type = ContractPartnerActionTypes.DeleteResponse;
    constructor(public Payload: number) {}
}

export type ContractPartnerActions =
    | GetContractPartnersRequest
    | GetContractPartnersResponse
    | PostContractPartnerRequest
    | PostContractPartnerResponse
    | DeleteContractPartnerRequest
    | DeleteContractPartnerResponse;
